<script lang="ts">
	import type { Model, Manufacturer, SearchField } from 'utility/search-fields'
	import type { Type } from 'components/search/ModelAutocomplete.svelte'
	import type { ComponentProps } from 'svelte'
	import type { SvelteSet } from 'svelte/reactivity'

	import Pin from 'components/search/Pin.svelte'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import ModelAutocomplete from './ModelAutocomplete.svelte'

	interface Props extends ComponentProps<typeof ModelAutocomplete> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		model?: Model | null
		manufacturer: Manufacturer | null
		initialValue?: number // For initial value binding
		type: Type // no default, require that they pass it
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		model = $bindable(null),
		manufacturer,
		initialValue,
		type,
		disabled = false,
		...rest
	}: Props = $props()
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<ModelAutocomplete
		{...rest}
		{type}
		{initialValue}
		{manufacturer}
		bind:model
		disabled={disabled || inEditMode}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</ModelAutocomplete>
</EditModeControls>
